import React, { useState, useEffect } from 'react';

import { Container, Logo, Navigation, MobileTrigger, Spacer } from './styles';

import { Link } from 'react-scroll';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const [headerSticky, setHeaderSticky] = useState(false);

  function handleScroll() {
    // console.log('scrollTop', document.documentElement.scrollTop);
    // console.log('clientHeight', document.documentElement.clientHeight);
    // console.log('clientHeight - 2', document.documentElement.clientHeight - 2);

    if (document.documentElement.scrollTop >= 280) {
      // setScroll(document.documentElement.clientHeight);
      setHeaderSticky(true);
    } else {
      // setScroll(document.documentElement.clientHeight);
      setHeaderSticky(false);
    }
  }

  useEffect(() => {
    window.onscroll = () => handleScroll();
  }, []);

  function handleMobileMenu() {
    if (mobileOpen) {
      return setMobileOpen(false);
    }
    setMobileOpen(true);
  }

  return (
    <>
      {headerSticky ? <Spacer /> : ''}
      <Container className={headerSticky ? 'sticky' : ''}>
        <MobileTrigger
          className={mobileOpen ? 'isOpen' : 'isClosed'}
          onClick={handleMobileMenu}
        >
          <span></span>
        </MobileTrigger>
        <Logo>
          <Link
            activeClass="active"
            to="intro"
            spy={true}
            smooth={true}
            // offset={200}
            offset={0}
            duration={500}
          >
            <span>Fundação São Paulo | PUC-SP</span>
          </Link>
        </Logo>
        <Navigation className={mobileOpen ? 'isOpen' : 'isClosed'}>
          <ul>
            <li>
              <Link
                activeClass="active"
                to="conheca"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={handleMobileMenu}
              >
                Conheça
              </Link>
            </li>            
            <li>
              <Link
                activeClass="active"
                to="projetos"
                spy={true}
                smooth={true}
                // offset={200}
                offset={-150}
                duration={500}
                onClick={handleMobileMenu}
              >
                Projetos
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="passoapasso"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={handleMobileMenu}
              >
                Passo a Passo
              </Link>
            </li>            
            <li>
              <Link
                activeClass="active"
                to="depoimentos"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={handleMobileMenu}
              >
                Depoimentos
              </Link>
            </li>

            <li>
              <Link
                activeClass="active"
                to="faq"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={handleMobileMenu}
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="contato"
                spy={true}
                smooth={true}
                offset={-210}
                duration={500}
                onClick={handleMobileMenu}
              >
                Contato
              </Link>
            </li>
          </ul>
        </Navigation>
      </Container>
    </>
  );
}
